import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import MyTimeSheet from "components/UI/MyTimeSheet";
import TeamTimeSheet from "components/UI/TeamTimeSheet";
import { useUserData } from "components/customHooks/userDataContext";

import { getUserOrgDetails } from "apiHandler/actions";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const BasicTabs = () => {
  const [value, setValue] = useState(0);

  const [userOrgData, setUserOrgData] = useState({});
  const userData = useUserData();

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    const payload = {
      user_id: userData?.email,
    };
    const response = await getUserOrgDetails(payload);
    console.log("userOrgData", response);
    if (response) {
      setUserOrgData(response[0]);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="My Timesheets" {...a11yProps(0)} />
          {userOrgData && userOrgData.employee_count === 0 ? null : (
            <Tab label="Team Timesheets" {...a11yProps(1)} />
          )}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <MyTimeSheet />
      </TabPanel>
      {userOrgData && userOrgData.employee_count === 0 ? null : (
        <TabPanel value={value} index={1}>
          <TeamTimeSheet />
        </TabPanel>
      )}
    </Box>
  );
};

export default BasicTabs;
